import { QueryFunctionContext } from 'react-query/types/core/types';
import { APIMethods, apiProxy, Message, TResponse } from 'utils/api/apiRequestProxy';
import api from 'utils/api/index';
import { FeedLog, IActivityFeedItem, IActivityFeedQuery, ReqFeedLogs, TMotionAlertEvent, TMotionAlertsInvoiceRequestStatus } from './types';

export const requestFeed = (query?: IActivityFeedQuery) => {
    return apiProxy<IActivityFeedItem[]>({
        url: '/event-feed/',
        method: APIMethods.GET,
        params: query,
        respKey: 'events_feed',
    });
};

export async function requestFeedLogs({ queryKey }: QueryFunctionContext<[string, ReqFeedLogs]>): Promise<TResponse<FeedLog[]>> {
    const [, query] = queryKey;
    return apiProxy<FeedLog[]>({
        url: '/intercom-bq-logs',
        method: APIMethods.GET,
        params: query,
    });
}

export const requestUpdateFeed = (data: { id: string; note: string }) => {
    const { id, ...payload } = data;
    return apiProxy<IActivityFeedItem[]>({
        url: `/event-feed/${id}`,
        method: APIMethods.PUT,
        data: payload,
    });
};

export type ReqMotionAlertEventsParams = {
    event_id?: string;
    access_point_id?: string;
    motion_event_id?: string;
    gt_created_date?: string;
    lt_created_date?: string;
};

export type ReqMotionAlertsInvoice = {
    notes?: string;
};

export const requestGetMotionAlertEvent = (params: ReqMotionAlertEventsParams): Promise<TResponse<TMotionAlertEvent[]>> => {
    return apiProxy<TMotionAlertEvent[]>({
        url: '/motion-alerts/events',
        method: APIMethods.GET,
        params,
        respKey: 'events',
    });
};

export const requestGetMotionAlertEventVideo = async (eventId: string): Promise<{ video_url: string }> => {
    const response = await api.get(`/motion-alerts/events/${eventId}/video`);
    // api interceptor returns response.data directly
    // typically backend sends { data: { video_url: '...' }, metadata: {...} }
    return response?.data || response;
};

export const requestGetMotionAlertsInvoiceRequest = (): Promise<TResponse<TMotionAlertsInvoiceRequestStatus>> => {
    return apiProxy<TMotionAlertsInvoiceRequestStatus>({
        url: '/motion-alerts/request-invoice',
        method: APIMethods.GET,
    });
};

export const requestMotionAlertsInvoice = (payload: ReqMotionAlertsInvoice): Promise<TResponse<Message>> => {
    return apiProxy<Message>({
        url: '/motion-alerts/request-invoice',
        method: APIMethods.POST,
        data: payload,
    });
};
